import { Injectable, inject, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NotifyService } from '../../shared/services/notify.service';
import { CONTENT_SYNC_ERROR_MESSAGE } from '../../shared/constants/content-sync-messages';

@Injectable({
    providedIn: 'root',
})
export class ContentSyncService {
    private readonly http = inject(HttpClient);
    private readonly notify = inject(NotifyService);
    private syncRequest$?: Observable<null>;

    /**
     * Telemetry hook (AB#8988 / ERR-007): incremented every time
     * syncOnAppOpen's HTTP call fails, so any future ops-facing surface
     * (a dashboard widget, an Application Insights custom event, etc.) can
     * observe aggregate failure counts without content-sync.service knowing
     * about that surface. No backend telemetry endpoint exists yet — see
     * the AB#8988 follow-up ticket for wiring this to a real sink.
     */
    readonly syncFailureCount: WritableSignal<number> = signal(0);

    syncOnAppOpen(): Observable<null> {
        if (!this.syncRequest$) {
            this.syncRequest$ = this.http
                .post<null>(
                    `${environment.apiUrl}/Content/sync-from-feeder`,
                    {},
                )
                .pipe(
                    catchError((error: unknown) => {
                        console.error('Content sync failed', error);
                        this.syncFailureCount.update((count) => count + 1);
                        this.notify.errorFrom(
                            error,
                            CONTENT_SYNC_ERROR_MESSAGE,
                        );
                        return of(null);
                    }),
                    shareReplay(1),
                );
        }

        return this.syncRequest$;
    }
}
